import { IGameObject } from "../IGameObject";
import World from "../World";

class PlayerPhysics {
    public height: number;

    public mass: number;

    public friction: number;

    public groundHeight: number;

    public onGround: boolean;

    public world: World;

    // TODO gameObject should be aware of physics, physics should not be aware of gameObject... Remove this, and pass in stuff to update?
    public gameObject: IGameObject;

    constructor(
        height: number,
        mass: number,
        world: World,
        gameObject: IGameObject
    ) {
        this.height = height;
        this.mass = mass;
        this.friction = 5;
        this.groundHeight = 0;
        this.onGround = false;
        this.world = world;
        this.gameObject = gameObject;
    }

    public update(delta: number): void {
        const { groundHeight, height, mass, friction, world, gameObject } =
            this;

        // Gravity.
        gameObject.velocity.y -= mass * delta;

        // Friction.
        gameObject.velocity.x -= gameObject.velocity.x * friction * delta;
        gameObject.velocity.z -= gameObject.velocity.z * friction * delta;

        // Velocity.
        gameObject.position.x += gameObject.velocity.x * delta;
        gameObject.position.y += gameObject.velocity.y * delta;
        gameObject.position.z += gameObject.velocity.z * delta;

        // Collisions.
        // Cast from far above the player down so we can be sure we don't miss the ground.
        this.groundHeight = world.getGroundIntersection(
            gameObject.position,
            groundHeight
        );

        if (gameObject.position.y < groundHeight + height) {
            gameObject.position.y = groundHeight + height;
            gameObject.velocity.y = 0;
            this.onGround = true;
        }
    }
}

export default PlayerPhysics;
